var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"praise flex-align-between"},[_c('img',{attrs:{"src":_vm.imgShow?_vm.img1:_vm.img2},on:{"click":_vm.imgCut}}),_c('span',{class:{num:_vm.imgShow}},[_vm._v(_vm._s(_vm.num))])])}
var staticRenderFns = []

export { render, staticRenderFns }